export default __webpack_public_path__ + "static/media/os_fedora.7129df24.svg";